import { useCommonStore } from "@/stores";
import styles from "./index.module.scss";
import { VideoPlayer } from "@/components";
import { useEffect } from "react";

const Result = () => {
  const task = useCommonStore(state => state.task);
  const sourceImgBlobUrl = useCommonStore(state => state.sourceImgBlobUrl);
  const isMute = useCommonStore(state => state.isMute);
  const isPlayResult = useCommonStore(state => state.isPlayResult);
  const setIsMute = useCommonStore(state => state.setIsMute);
  const setIsPlayResult = useCommonStore(state => state.setIsPlayResult);
  const updatePlayState = useCommonStore(state => state.updatePlayState);

  useEffect(() => {
    return () => {
      setIsPlayResult(false);
    }
  }, []);

  return (
    <div
      className={styles["result"]}
    >
      <VideoPlayer
        isMute={isMute}
        isPlay={isPlayResult}
        videoSrc={task?.videoPath!}
        imgSrc={sourceImgBlobUrl}
        compareVisible
        setIsMute={setIsMute}
        setIsPlay={setIsPlayResult}
        onPlay={() => updatePlayState(false)}
      ></VideoPlayer>
    </div>
  )
}

export default Result;